import { render, staticRenderFns } from "./ScoringProfilesModelCreate.vue?vue&type=template&id=f34370a4&scoped=true"
import script from "./ScoringProfilesModelCreate.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesModelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34370a4",
  null
  
)

export default component.exports